import React from 'react';
import * as S from './style';
import AssignmentIcon from '~images/parent-signup/assignment_icon.svg'
import FaceIcon from '~images/parent-signup/face_icon.svg'
import StarIcon from '~images/parent-signup/star_icon.svg'
import { assetPath } from '../../../utils/web-helper';

const LeftPanel = () => {
  return(
    <S.SignupContainerLeftPanel>
      <S.ParentStudentSignupImage/>
      <S.ParentSignupSubText>Kids see fun. You see real learning outcomes.</S.ParentSignupSubText>
      <SignupBenefits/>
    </S.SignupContainerLeftPanel>
  )
}

const SignupBenefits = () => {
  const benefits = [
    {
      text: "Personalised Learning",
      imgSrc: FaceIcon
    },
    {
      text: "Fun Rewards",
      imgSrc: StarIcon
    },
    {
      text: "Actionable Reports",
      imgSrc: AssignmentIcon
    }
  ]
  return(
    <S.SignupBenefitsContainer>
      {benefits.map(({text, imgSrc}) => 
        <S.SignupBenefit key={"ParentSignupBenefit_"+text.replace(/\s/g, "")}>
          <S.SignupBenefitIcon src={assetPath(imgSrc)}/>
          <S.SignupBenefitText>{text}</S.SignupBenefitText>
        </S.SignupBenefit>
      )}
    </S.SignupBenefitsContainer>
  )
}

export default LeftPanel;